import {formatGroszeAsZlotyLatex} from "../../utils/formatGroszeAsZlotyLatex";
const step=(title,math)=>({title,math});
const dec=n=>String(Number(n.toFixed(8))).replace(".","{,}");
const frac=(n,d)=>{
 const sign=n*d<0?"-":"";let a=Math.abs(n),b=Math.abs(d),x=a,y=b;
 while(y)[x,y]=[y,x%y];a/=x;b/=x;
 return b===1?`${sign}${a}`:String.raw`${sign}\frac{${a}}{${b}}`;
};
export function getLinearSystemSolutionSteps(task){
 const v=task.data?.values;if(!v)return null;
 switch(task.type){
  case "MaturaBasic_TreesSystemModel": {
   const [total,added,ratio]=v;return [
    step("Oznaczamy początkowe liczby drzew. Ich suma jest podana w treści.",String.raw`x+y=${total}`),
    step("Dosadzono tylko drzewa iglaste. Zmieniamy więc całe wyrażenie opisujące ich liczbę.",String.raw`\text{iglaste: }x+${added},\qquad\text{liściaste: }y`),
    step("Liczba drzew liściastych jest podaną wielokrotnością nowej liczby iglastych. Mnożnik obejmuje cały nawias.",String.raw`y=${ratio}(x+${added})`),
   ];
  }
  case "MaturaBasic_TwoOrchardsPercentLossSystemSelection": {
   const [N,p,q,k]=v,a=dec((100-p)/100),b=dec((100-q)/100),ratio=dec(k/100);return [
    step("Niewiadome oznaczają początkowe liczby drzew. Zapisujemy ich łączną liczbę.",String.raw`x+y=${N}`),
    step("Po usunięciu uschniętych drzew pozostaje odpowiedni procent początkowej liczby.",String.raw`\text{pierwszy sad: }${a}x,\qquad\text{drugi sad: }${b}y`),
    step("Pozostała liczba w drugim sadzie stanowi podany procent pozostałej liczby w pierwszym.",String.raw`${b}y=${ratio}\cdot${a}x`),
    step("Łączymy obie zależności w układ i wybieramy równoważną odpowiedź.",String.raw`\begin{cases}x+y=${N}\\${ratio}\cdot${a}x=${b}y\end{cases}`),
   ];
  }
  case "MaturaBasic_RetailMarkupLinearSystemModel": {
   const [n,m,total,p,q]=v;return [
    step("x i y oznaczają ceny hurtowe jednej sztuki. Mnożymy je przez liczby kupionych sztuk.",String.raw`${n}x+${m}y=${total}`),
    step("Marża zwiększa cenę o wskazany procent. Do ceny początkowej dodajemy podwyżkę.",String.raw`x+${dec(p/100)}x=${dec(1+p/100)}x,\qquad y+${dec(q/100)}y=${dec(1+q/100)}y`),
    step("Ceny detaliczne są równe. Łączymy tę informację z łącznym kosztem zakupu.",String.raw`\begin{cases}${n}x+${m}y=${total}\\${dec(1+p/100)}x=${dec(1+q/100)}y\end{cases}`),
   ];
  }
  case "MaturaBasic_RectanglePerimeterDifferenceTwoSystems": {
   const [p,d]=v;return [
    step("Obwód prostokąta jest sumą długości czterech boków.",String.raw`2a+2b=${p}\iff2(a+b)=${p}`),
    step("a jest dłuższym bokiem. Różnica długości daje drugie równanie.",String.raw`a-b=${d}\iff b=a-${d}`),
    step("Szukamy dwóch układów zawierających po jednej równoważnej postaci obu zależności.",String.raw`\begin{cases}2(a+b)=${p}\\b=a-${d}\end{cases}\qquad\begin{cases}2a+2b=${p}\\a-b=${d}\end{cases}`),
   ];
  }
  case "MaturaBasic_shopping-two-linear-equations-price": {
   const [x10,y10]=v,x=x10/10,y=y10/10,t1=8*x+4*y,t2=3*x+9*y;return [
    step("Oznaczamy ceny jednej czekolady i jednego batonu przez x i y. Koszt każdego zakupu daje osobne równanie.",String.raw`\begin{cases}8x+4y=${dec(t1)}\\3x+9y=${dec(t2)}\end{cases}`),
    step("Mnożymy pierwsze równanie przez 9, a drugie przez 4, aby współczynniki przy y były równe.",String.raw`\begin{cases}72x+36y=${dec(9*t1)}\\12x+36y=${dec(4*t2)}\end{cases}`),
    step("Odejmujemy równania stronami. Wyrazy z y redukują się.",String.raw`60x=${dec(9*t1)}-${dec(4*t2)}=${dec(60*x)}\quad\Rightarrow\quad x=${formatGroszeAsZlotyLatex(x10*10)}\;\text{zł}`),
    step("Podstawiamy cenę do układu i sprawdzamy oba zakupy. Odpowiedzią jest cena czekolady w złotych.",String.raw`8\cdot${formatGroszeAsZlotyLatex(x10*10)}+4\cdot${formatGroszeAsZlotyLatex(y10*10)}=${dec(t1)},\qquad3\cdot${formatGroszeAsZlotyLatex(x10*10)}+9\cdot${formatGroszeAsZlotyLatex(y10*10)}=${dec(t2)}`),
   ];
  }
  case "MaturaBasic_SymmetricLinearSystemSignsTruth": {
   const [a,b]=v;return [
    step("Dzielimy każde równanie przez jego dodatni wspólny współczynnik.",String.raw`x_0+y_0=${frac(1,a)},\qquad x_0-y_0=${frac(1,b)}`),
    step("Suma jest dodatnia, ponieważ jest odwrotnością liczby dodatniej. Pierwsze stwierdzenie jest prawdziwe.",String.raw`x_0+y_0=${frac(1,a)}>0`),
    step("Dodajemy i odejmujemy równania, aby obliczyć obie niewiadome.",String.raw`x_0=${frac(a+b,2*a*b)},\qquad y_0=${frac(b-a,2*a*b)}`),
    step("Sprawdzamy znak iloczynu. Mianownik jest dodatni, więc o znaku decyduje licznik.",String.raw`x_0y_0=${frac(b*b-a*a,4*a*a*b*b)}${b>a?">":b===a?"=":"<"}0`),
   ];
  }
  case "MaturaBasic_LinearSystemCoefficientProduct": {
   const [a,b,x,y]=v,r1=a*x+3*y,r2=x+b*y;return [
    step("Wstawiamy podane wartości x i y do obu równań. Niewiadomymi są teraz a i b.",String.raw`\begin{cases}a\cdot(${x})+3\cdot${y}=${r1}\\${x}+b\cdot${y}=${r2}\end{cases}`),
    step("W pierwszym równaniu odejmujemy znany składnik i dzielimy przez współczynnik przy a.",String.raw`a\cdot(${x})=${r1}-${3*y}=${a*x}\quad\Rightarrow\quad a=${a}`),
    step("W drugim równaniu odejmujemy x i dzielimy przez y.",String.raw`b\cdot${y}=${r2}-(${x})=${b*y}\quad\Rightarrow\quad b=${b}`),
    step("Obliczamy iloczyn wskazany w pytaniu.",String.raw`a\cdot b=(${a})\cdot${b}=${a*b}`),
   ];
  }
  case "MaturaBasic_LinearSystemDependentEquationsSolutionCount": {
   const [b,c,k,delta]=v;return [
    step("Mnożymy pierwsze równanie przez współczynnik stojący przy x w drugim.",String.raw`x-${b}y=${c}\quad\Rightarrow\quad ${k}x+${-k*b}y=${k*c}`),
    step("Porównujemy prawe strony. Lewe strony są identyczne.",String.raw`${k*c}${delta===0?"=":"\\ne"}${k*c+delta}`),
    step(delta===0?"Oba równania opisują tę samą prostą. Układ ma nieskończenie wiele rozwiązań.":"Identyczne lewe strony nie mogą być równe różnym liczbom. Proste są równoległe i różne; układ nie ma rozwiązań.",delta===0?String.raw`S=\{(x;y):x-${b}y=${c}\}`:String.raw`S=\varnothing`),
   ];
  }
  case "MaturaBasic_TwoLinearEquationsSolutionPair": {
   const [x,y,a,b]=v,c=a*y-x,d=-b*x-y;return [
    step("Z pierwszego równania wyznaczamy x.",String.raw`x-${a}y+(${c})=0\iff x=${a}y-(${c})`),
    step("Podstawiamy wyrażenie za x do drugiego równania i wyznaczamy y.",String.raw`${b}(${a}y-(${c}))+y+(${d})=0\iff ${a*b+1}y=${b*c-d}\iff y=${y}`),
    step("Wracamy do wyrażenia na x i sprawdzamy obie wartości.",String.raw`x=${a}\cdot${y}-(${c})=${x},\qquad (x;y)=(${x};${y})`),
   ];
  }
  case "MaturaBasic_CoordinatePointChooseTwoLineEquations": {
   const [x,y]=v;return [
    step("Punkt przecięcia musi należeć do obu prostych. Podstawiamy jego współrzędne do pierwszego równania wybranej pary.",String.raw`x-y=(${x})-(${y})=${x-y}`),
    step("Sprawdzamy także drugie równanie tej samej pary.",String.raw`-2x+y=-2\cdot(${x})+(${y})=${-2*x+y}`),
    step("Obie równości zachodzą. Po wyznaczeniu y otrzymujemy różne współczynniki kierunkowe: 1 i 2, więc proste mają dokładnie jeden wspólny punkt.",String.raw`y=x-(${x-y}),\qquad y=2x+(${y-2*x}),\qquad S=\{(${x};${y})\}`),
   ];
  }
  case "MaturaBasic_TwoLinesGraphChooseSystem": {
   const [b,k,c]=v;return [
    step("Malejąca prosta przecina oś Oy w dodatnim punkcie. Ze spadku o jedną jednostkę przy wzroście x o jeden odczytujemy nachylenie.",String.raw`y=-x+${b}`),
    step("Rosnąca prosta przecina oś Oy poniżej zera. Odczytujemy jej nachylenie.",String.raw`y=${k}x-${c}`),
    step("Obie odczytane proste zapisujemy jako jeden układ.",String.raw`\begin{cases}y=-x+${b}\\y=${k}x-${c}\end{cases}`),
   ];
  }
  case "MaturaBasic_LinearSystemGraphSelection": {
   const [shift,a]=v;return [
    step("Współczynniki kierunkowe mają przeciwne znaki. Jeden wykres rośnie, drugi maleje.",String.raw`a_1=${a},\qquad a_2=-${a}`),
    step("Przyrównujemy prawe strony, aby znaleźć punkt przecięcia.",String.raw`${a}x-${a*shift}=-${a}x+${a*shift}\iff ${2*a}x=${2*a*shift}\iff x=${shift}`),
    step("Podstawiamy x do dowolnego równania i wybieramy wykres z właściwym punktem przecięcia.",String.raw`y=${a}\cdot${shift}-${a*shift}=0,\qquad P=(${shift};0)`),
   ];
  }
  default:return null;
 }
}
